import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../api";

const KEY = "qora_consent"; // "granted" | "denied"
let settings = null;

const gtag = (...a) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push(a); };

function loadGtag(id) {
  if (!id || document.getElementById("qora-gtag")) return;
  const s = document.createElement("script"); s.id = "qora-gtag"; s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`; document.head.appendChild(s);
  gtag("js", new Date());
  gtag("config", id, { anonymize_ip: true });
  if (settings?.ads_conversion_id) gtag("config", settings.ads_conversion_id);
}

export function applyConsent(choice) {
  localStorage.setItem(KEY, choice);
  gtag("consent", "update", { analytics_storage: choice === "granted" ? "granted" : "denied", ad_storage: choice === "granted" ? "granted" : "denied", ad_user_data: choice === "granted" ? "granted" : "denied", ad_personalization: choice === "granted" ? "granted" : "denied" });
}

export function trackEvent(name, params = {}) { if (settings?.ga4_id) gtag("event", name, params); }
export function trackConversion(kind, value, currency = "EUR") {
  const label = kind === "trial" ? settings?.ads_conversion_label_trial : settings?.ads_conversion_label_purchase;
  if (settings?.ads_conversion_id && label) gtag("event", "conversion", { send_to: `${settings.ads_conversion_id}/${label}`, value, currency });
  trackEvent(kind === "trial" ? "begin_trial" : "purchase", { value, currency });
}

export default function Analytics() {
  const [show, setShow] = useState(false);
  useEffect(() => { (async () => {
    try {
      const { data } = await api.seoPublicSettings(); settings = data;
      if (data.gsc_verification && !document.querySelector('meta[name="google-site-verification"]')) { const m = document.createElement("meta"); m.name = "google-site-verification"; m.content = data.gsc_verification; document.head.appendChild(m); }
      if (data.bing_verification && !document.querySelector('meta[name="msvalidate.01"]')) { const m = document.createElement("meta"); m.name = "msvalidate.01"; m.content = data.bing_verification; document.head.appendChild(m); }
      if (!data.ga4_id) return;
      gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", wait_for_update: 500 });
      loadGtag(data.ga4_id);
      const c = localStorage.getItem(KEY);
      if (c) applyConsent(c); else setShow(true);
    } catch {}
    try { if (/bot|crawl|spider|gpt|claude|perplexity/i.test(navigator.userAgent)) api.seoHit(window.location.pathname); } catch {}
  })(); }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[60] rounded-2xl bg-[#0c2d34] text-white p-4 shadow-2xl" data-testid="cookie-banner">
      <div className="flex gap-3"><Cookie className="h-5 w-5 text-[#8fd7c4] shrink-0 mt-0.5" />
        <div className="text-sm"><p className="font-semibold">Cookie e statistiche</p><p className="text-white/70 mt-1">Usiamo cookie analitici (Google Analytics) solo con il tuo consenso per capire come migliorare Qora. <Link to="/cookie" className="underline">Informativa cookie</Link></p>
          <div className="flex gap-2 mt-3">
            <Button size="sm" className="bg-[#8fd7c4] text-[#0c2d34] hover:bg-[#8fd7c4]/90 font-bold" onClick={() => { applyConsent("granted"); setShow(false); }} data-testid="consent-accept">Accetta</Button>
            <Button size="sm" variant="outline" className="border-white/30 bg-transparent text-white hover:bg-white/10 hover:text-white" onClick={() => { applyConsent("denied"); setShow(false); }} data-testid="consent-reject">Solo necessari</Button>
          </div></div></div>
    </div>
  );
}
